import React from "react";
import { Button, Form } from "react-bootstrap";
import Icon1 from '../../assets/images/Social/Icon1.svg'
import Icon2 from '../../assets/images/Social/Icon2.svg'
import Icon3 from '../../assets/images/Social/Icon3.svg'
import Icon4 from '../../assets/images/Social/Icon4.svg'
import Icon5 from '../../assets/images/Social/Icon5.svg'
import Icon6 from '../../assets/images/Social/Icon6.svg'


function Banner() {

    return (
        <section className="stay-loop section-margin">
            <div className="container">
                <div className="section-wrapper bg-drak">
                    <div className="inner-wrapper">
                        <h2>Stay In The Loop</h2>
                        <h5>Join our mailing list to stay in the loop with our newest feature releases, NFT drops, and tips and tricks for navigating Toppy.</h5>
                        <form>
                            <Form.Control placeholder="Email Address" />
                            <Button variant="primary">SIGN UP</Button>
                        </form>
                    </div>
                    <div className="community-sec">
                        <h2>Join Our Community</h2>
                        <div className="social-links">
                            <ul >
                                <li>
                                    <a href="#">
                                        <img src={Icon1} alt="" className="img-fluid" />
                                    </a>
                                </li>
                                <li>
                                    <a href="#">
                                        <img src={Icon2} alt="" className="img-fluid" />
                                    </a>
                                </li>
                                <li>
                                    <a href="#">
                                        <img src={Icon3} alt="" className="img-fluid" />
                                    </a>
                                </li>
                                <li>
                                    <a href="#">
                                        <img src={Icon4} alt="" className="img-fluid" />
                                    </a>
                                </li>
                                <li>
                                    <a href="#">
                                        <img src={Icon5} alt="" className="img-fluid" />
                                    </a>
                                </li>
                                <li>
                                    <a href="#">
                                        <img src={Icon6} alt="" className="img-fluid" />
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>

                </div>
            </div>
        </section>
    )
}
export default Banner;